import {
  Component,
  OnInit,
  Renderer2,
  OnChanges,
  Output,
  ElementRef,
  EventEmitter,
  ViewChild,
  SecurityContext,
} from '@angular/core'
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms'
import { DomSanitizer } from '@angular/platform-browser'
import { CommonService } from '../../../../../shared/services/common.service'
import { environment } from '../../../../../../environments/environment'

@Component({
  standalone: false,
  selector: 'vs-feedback-attachments',
  templateUrl: './feedback-attachments.component.html',
  styleUrls: ['./feedback-attachments.component.scss'],
})
export class FeedbackAttachmentsComponent implements OnInit {
  @Output() updateFiles = new EventEmitter<any>()
  @Output() removeFile = new EventEmitter<any>()
  feedbackAttachmentForm: FormGroup
  @ViewChild('fileMaxLenghtExceednotify', { static: false })
  fileMaxLenghtExceednotify: ElementRef
  @ViewChild('fileTypeNotify', { static: false }) fileTypeNotify: ElementRef
  @ViewChild('fileSizeExceedNotify', { static: false })
  fileSizeExceedNotify: ElementRef
  @ViewChild('fileDuplicateNotify', { static: false })
  fileDuplicateNotify: ElementRef
  @ViewChild('fileInfoNotify', { static: false }) fileInfoNotify: ElementRef
  @ViewChild('filenameLengthNotify', { static: false })
  filenameLengthNotify: ElementRef

  constructor(
    private commonService: CommonService,
    private formBuilder: FormBuilder,
    private renderer: Renderer2,
    private domSanitizer: DomSanitizer
  ) {}

  public myFilesNotification: string[] = []
  public uploadedFiles: any[] = []
  public totalAllFiles: any = 0

  public myFiles: string[] = []
  public disbledBtn = false

  ngOnInit(): void {
    this.createFeedbackAttachmentForm()
  }

  createFeedbackAttachmentForm() {
    this.feedbackAttachmentForm = this.formBuilder.group({
      upload: new FormControl('', Validators.required),
    })
  }

  upload(event) {
    let _this = this
    let filesTotal = 0
    let totalUploadedFiles = 0
    let totalFileSize = 0
    let prevFiles: any = 0

    this.fileMaxLenghtExceednotify.nativeElement.innerHTML = ''
    this.fileTypeNotify.nativeElement.innerHTML = ''
    this.fileSizeExceedNotify.nativeElement.innerHTML = ''
    this.fileDuplicateNotify.nativeElement.innerHTML = ''
    this.filenameLengthNotify.nativeElement.innerHTML = ''
    const uploadDiv = this.fileInfoNotify.nativeElement

    const uploadedFilesCount = document.querySelectorAll(
      '.fileDivID-sectionnotify'
    )
    let isDuplicateFiles = false
    let allFileNames = []
    for (let j = 0; j < uploadedFilesCount.length; j++) {
      let size = parseInt(uploadedFilesCount[j].getAttribute('data-size'))
      allFileNames.push(uploadedFilesCount[j].getAttribute('data-filename'))
      prevFiles = prevFiles + size
    }
    let totalSize = prevFiles

    if (
      event.target.files.length <= 5 &&
      event.target.files.length + uploadedFilesCount.length <= 5
    ) {
      if (
        event.target.files.length == 5 ||
        event.target.files.length + uploadedFilesCount.length == 5
      ) {
        this.disbledBtn = true
      }

      for (let a = 0; a < event.target.files.length; a++) {
        totalSize += event.target.files[a].size
        allFileNames.forEach((file) => {
          if (event.target.files[a].name == file) {
            this.fileDuplicateNotify.nativeElement.innerHTML =
              'File Already exists'
            isDuplicateFiles = true
            this.disbledBtn = false
          }
        })
      }

      let filesMB = Math.round((totalSize / (1024 * 1024)) * 100) / 100 // in MB
      if (filesMB <= 30) {
        if (!isDuplicateFiles) {
          for (let i = 0; i < event.target.files.length; i++) {
            let res_field = event.target.files[i].name
            let extension = res_field
              .substr(res_field.lastIndexOf('.') + 1)
              .toLowerCase()
            let allowedExtensions = ['xlsx', 'doc', 'jpg', 'png', 'pdf', 'jpeg']
            totalSize += event.target.files[i].size
            if (event.target.files[i].name.trim().length > 30) {
              this.filenameLengthNotify.nativeElement.innerHTML =
                'File name length should not be greater than 30 characters'
              return
            }
            if (allowedExtensions.indexOf(extension) === -1) {
              this.fileTypeNotify.nativeElement.innerHTML =
                'File format is not supported'
              this.disbledBtn = false
            } else {
              this.uploadedFiles.push({
                filename: event.target.files[i].name,
                filesize: event.target.files[i].size,
              })
              const fileDivNotify = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createElement('div')
              )
              this.renderer.appendChild(uploadDiv, fileDivNotify)
              this.renderer.setAttribute(fileDivNotify, 'id', 'fileDivID')
              this.renderer.setAttribute(
                fileDivNotify,
                'class',
                'fileDivIDUpload'
              )
              this.renderer.setAttribute(
                fileDivNotify,
                'data-size',
                event.target.files[i].size
              )
              this.renderer.setAttribute(
                fileDivNotify,
                'data-filename',
                event.target.files[i].name
              )
              this.renderer.addClass(fileDivNotify, 'fileDivID-sectionnotify')
              const fileIcon = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createElement('i')
              )
              this.renderer.appendChild(fileDivNotify, fileIcon)
              this.renderer.addClass(fileIcon, 'material-icons')
              this.renderer.addClass(fileIcon, 'material-icons-custom')
              const iconText = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createText('receipt')
              )
              this.renderer.appendChild(fileIcon, iconText)
              const fileName = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createElement('p')
              )
              this.renderer.appendChild(fileDivNotify, fileName)
              this.renderer.setAttribute(fileName, 'id', 'para11')
              const fileNameText = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createText(event.target.files[i].name)
              )
              const fileNameString = event.target.files[i].name
              this.renderer.appendChild(fileName, fileNameText)
              const fileSize = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createElement('p')
              )
              this.renderer.appendChild(fileDivNotify, fileSize)
              this.renderer.setAttribute(fileSize, 'id', 'para22')
              const fileNameSize = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createText(
                  // 'Size: ' + Math.round(event.target.files[i].size / 1024) + 'KB'
                  ' ' + this.getFileSize(event.target.files[i].size)
                )
              )
              this.renderer.appendChild(fileSize, fileNameSize)
              const closeIcon = this.renderer.createElement('a')
              this.renderer.appendChild(fileDivNotify, closeIcon)
              this.renderer.setAttribute(closeIcon, 'id', `${i}`)
              this.renderer.setAttribute(
                closeIcon,
                'data-name',
                event.target.files[i].name
              )
              this.renderer.addClass(closeIcon, 'closeId-img')
              //const fileNameClose = this.renderer.createText('x');
              const span = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createElement('span')
              )
              // const text = this.renderer.createText('X');
              const imageElem = this.domSanitizer.sanitize(
                SecurityContext.NONE,
                this.renderer.createElement('img')
              )
              const imageElemSrc = this.renderer.setAttribute(
                imageElem,
                'src',
                environment.deployPath + '/assets/img/vector.png'
              )
              this.renderer.appendChild(span, imageElem)
              this.renderer.appendChild(closeIcon, span)
              closeIcon.addEventListener('click', function (removeEvent) {
                _this.disbledBtn = false
                _this.removeFile.emit(fileNameString)
                this.parentElement.remove()
                _this.fileMaxLenghtExceednotify.nativeElement.innerHTML = ' '

                for (let z = 0; z < totalUploadedFiles; z++) {
                  if (
                    this.getAttribute('data-name') ==
                    _this.uploadedFiles[z].filename
                  ) {
                    prevFiles = 0
                    _this.uploadedFiles.splice(z, 1)
                    totalUploadedFiles = totalUploadedFiles - 1
                  }
                }
              })
              this.myFilesNotification.push(event.target.files[i])
              this.updateFiles.emit(this.myFilesNotification)
              totalUploadedFiles = totalUploadedFiles + 1
            }
          } // for ends
        } else {
          ///   'File already exists';
          this.fileDuplicateNotify.nativeElement.innerHTML =
            'File already exists'
        }
      } else {
        //  'file size exceeded';
        this.fileSizeExceedNotify.nativeElement.innerHTML =
          'File Size of all attachment should not exceed 30 MB'
        //'file size exceeded';
        this.disbledBtn = false
      }
    } else {
      //  'You have exceeded files';
      this.fileMaxLenghtExceednotify.nativeElement.innerHTML =
        'You have exceeded files'
    }
    event.target.value = ''
  }
  getFileSize(fileSize) {
    if (Math.round((fileSize / 1024) * 1000) / 1000 >= 1024.0) {
      return (Math.round(fileSize / 1024) / 1024).toFixed(2) + ' mb'
    }
    if (Math.round((fileSize / 1024) * 1000) / 1000 < 1024.0) {
      return (Math.round((fileSize / 1024) * 1000) / 1000).toFixed() + ' kb'
    }
    // return (fileSize / (1024 * 1024)).toFixed(1) + ' mb';
  }
}
